<div class="data-type-filter">
  <label for="data-type-select">{{ labels.title }}</label>
  <select
    [ngModel]="selectedDataType"
    (ngModelChange)="onDataTypeChange($event)"
    [disabled]="!isDetailPage"
  >
    <option value="default">{{ labels.default }}</option>
    <option value="gps">{{ labels.gps }}</option>
  </select>
</div>
